import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card } from "react-bootstrap";
import "./WhyBaytBuddyCard.css";
export default function WhyBaytBuddyCard({
  icon,
  title,
  description
}) {
  useLanguage();
  const Icon = icon;
  return <Card className="bb-why-card h-100">
    <Card.Body>
      <div className="bb-why-card__icon bb-icon">
        <Icon />
      </div>
      <div className="bb-why-card__title">{t(title)}</div>
      <p className="bb-why-card__description">{t(description)}</p>
    </Card.Body>
  </Card>;
}
